module.exports = __webpack_public_path__ + "static/media/title-slide-background.063c1902.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/title-slide-background.jpg
 ** module id = 98
 ** module chunks = 0
 **/